import React, { Component } from 'react'
import Button from '../Button'
import Tags from '../Tags'
import Tooltip from '../Tooltip'
import './pagetitle.scss'

class PageTitle extends Component {
	constructor(props) {
		super(props)

		this.state = {
			editBtn: props.editBtn ? props.editBtn : '',
			numModels: props.numModels ? props.numModels : '',
			regNum: props.regNum ? props.regNum : '',
			projDetails: props.projDetails ? props.projDetails : ''
		}
	}

	render() {
		let classes = ['vbui--page-title', this.props.classes].join(' ')
		return (
			<div className={classes}>
				<div className="top-row">
					<div className="left-block">
						<h1 className="page-main-title">{this.props.title}</h1>
						{this.state.editBtn && (
							<Button classes="ghost medium content-width" showIcon={true} icon="icon-icon-edit"></Button>
						)}
					</div>
					<div className="right-block">{this.props.children}</div>
				</div>
				{this.state.numModels && this.state.regNum && this.state.projDetails && (
					<div className="project-info">
						{this.state.numModels && <Tags state="active">{this.state.numModels} modelos</Tags>}
						{this.state.regNum && this.state.projDetails && (
							<div className="project-ref">
								{this.state.regNum} | Detalles del proyecto{' '}
								<div className="info-hover">
									<span className="icon-icon-tooltip-2"></span>
									<Tooltip classes="northwest">{this.state.projDetails}</Tooltip>
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		)
	}
}

export default PageTitle
